const FeaturesRepo = {
  featuresData: [
    {
      id: 1,
      icon: "zmdi zmdi-car",
      title: "Share a Ride",
      description:
        " We connect commuters among themselves or with drivers with the same route to share a ride",
    },
    {
      id: 2,
      icon: "zmdi zmdi-mood",
      title: "No commissions charged",
      description:
        "We don't take a share of hardly earned drivers who uses our platform instead we raise money from other value added services",
    },
    {
      id: 3,
      icon: "zmdi zmdi-whatsapp",
      title: "Carpooling group chats",
      description:
        "If no rides are available, create or join a group chat to organize a carpool with other riders",
    },
    {
      id: 4,
      icon: "zmdi zmdi-female",
      title: "Is female friendly",
      description:
        "Women may opt to activate a FEMALE MODE which enables them to only match with female drivers and fellow commuters",
    },
    {
      id: 5,
      icon: "zmdi zmdi-bus",
      title: "For Transit agencies",
      description: (
        <p>
          Transit agencies and transit data enthusiast may use our{" "}
          <a href="https://umma.nibebe.app" target="_blank" rel="noreferrer">
            data processing tool, called Umma,
          </a>{" "}
          to collect and process transit data which can export as GTFS or
          GeoJSON
        </p>
      ),
    },
  ],
};
export default FeaturesRepo;
